import {Outlet, useLocation, useHistory} from "react-router-dom";
import { useEffect, useRef, useState} from "react";
import {useEvoContext} from "../../context/evo.context";

export default function RootLayout() {

    const location = useLocation(); // Get the current location
    const {navHistory, setNavHistory} = useEvoContext();
    const previousLocation = useRef(location.pathname); // Ref initialized to null

     useEffect(() => {
         if(location.pathname == '/'){
             setNavHistory(['/']);
         } else {
             setNavHistory((prevArray) => [
                 ...prevArray, previousLocation.current]
             );
         }

    }, [location]); // Runs whenever location changes*/

    return (

        <div>

            <Outlet />
        </div>
    )
}

